<template>
  <div class="org-select">
    <div class="metadata-label">{{ documentMetadata.metadata.name }}</div>
    <vselect
      placeholder="Type to search by name..."
      v-model="localValue"
      :disabled="documentMetadata.metadata.isReadonly"
      :data-cy="documentMetadata.metadata.key"
      :options="connectedCompaniesList"
      label="name"
      :reduce="company => company.key"
    >
      <template #option="{ name }">
        <div class="pa-1">
          <b>{{ name }}</b>
        </div>
      </template>
      <template #no-options="{}"> Sorry, no matching {{ documentMetadata.metadata.name }} </template>
    </vselect>
  </div>
</template>

<script>
import metadataMixin from "@/mixins/metadataMixin";

export default {
  name: "CompanyMetadata",

  // Use the mixin to handle prop mutations properly
  mixins: [metadataMixin],

  props: {
    // documentMetadata is provided by the mixin
  },

  computed: {
    connectedCompaniesList() {
      return this.documentMetadata.party?.connectedOrgUnits == null
        ? []
        : Object.entries(this.documentMetadata.party.connectedOrgUnits).map(([key, value]) => ({
            key: parseInt(key),
            name: value,
          }));
    },
  },

  methods: {
    setDisplayValue(key) {
      this.updateMetadataProperty("displayValue", this.connectedCompaniesList.find(x => x.key === key)?.name);
    },
  },

  watch: {
    "documentMetadata.party": function(newValue, oldValue) {
      if (newValue?.connectedOrgUnits != null && Object.entries(newValue.connectedOrgUnits).length === 1) {
        // If there is only one available option, select that one
        this.localValue = parseInt(Object.entries(newValue.connectedOrgUnits)[0][0]);
      } else if (oldValue != null) {
        // Clear the value if a new party was selected and there was one selected before
        this.localValue = null;
      }

      if (this.documentMetadata.value != null) {
        // Set the display value for the selected company
        this.setDisplayValue(this.documentMetadata.value);
      }
    },

    "documentMetadata.value": function(newValue) {
      // Set the display value for the selected company
      this.setDisplayValue(newValue);
    },
  },

  async created() {
    if (this.documentMetadata.value) {
      this.localValue = parseInt(this.documentMetadata.value);
    }
  },
};
</script>
